import { NotFoundCard } from "../components/NotFoundCard";

/**
 * Catch-all `*` route (REDISENO-PANEL.md §3.4 + design.md §3: "Unknown
 * record IDs render a local not-found state with a safe return link; they
 * do not collapse to the overview"). Covers any unmatched top-level URL; a
 * record-specific not-found (unknown campaign/contact/template ID) uses the
 * SAME `NotFoundCard` with its own title (each feature's own screen).
 *
 * Both links are fixed literals (`/campanas`, `/`), never a client-supplied
 * `returnTo` — the same open-redirect defense discipline as
 * `api/client.ts#buildSafeReturnState` (PR2 review fix).
 */
export function NotFoundRoute() {
  return (
    <NotFoundCard
      ariaLabel="Página no encontrada"
      title="No encontramos esta página"
      description="Puede que el enlace esté mal escrito o que el elemento ya no exista o no esté disponible para tu cuenta."
      secondaryAction={{ label: "Ver campañas", to: "/campanas" }}
      primaryAction={{ label: "Ir al inicio", to: "/" }}
    />
  );
}
